import React from 'react';
import PropTypes from 'prop-types';
import {AppTitle} from '../nimbus/appTitle';

import logo from 'assets/images/ACDelco-logo-noR.png';

export class ACDelcoLogo extends React.Component {
  render() {
    const {className, imageAlt, ...otherProps} = this.props;
    return (
      <AppTitle className={className}
                imageSrc={logo}
                imageAlt={imageAlt}
                imageDimensions={{
                  height: 27,
                  width: 144,
                }}
                {...otherProps}
      ></AppTitle>
    );
  }
}

ACDelcoLogo.propTypes = {
  imageAlt: PropTypes.string.isRequired,
};

